import { Menu } from '@mui/icons-material';
import { useState } from 'react';

import { tApp, tCommon } from '@frontend/locales';

import { IconActionButton } from '../icon-action-button.component';
import { AppDrawer } from './app-drawer.component';

export const DrawerAction = () => {
  const [toggleDrawer, setToggleDrawer] = useState(false);

  return (
    <>
      <IconActionButton
        icon={<Menu />}
        onClick={() => setToggleDrawer(!toggleDrawer)}
        ariaDescription={tApp.drawer.description({
          action: toggleDrawer
            ? tCommon.actions.close()
            : tCommon.actions.open(),
        })}
        title={tApp.drawer.description({
          action: toggleDrawer
            ? tCommon.actions.close()
            : tCommon.actions.open(),
        })}
      />

      <AppDrawer openState={toggleDrawer} toggleDrawer={setToggleDrawer} />
    </>
  );
};
